import type { ViewjobQueryResult } from "../__generated__/viewjob.gqlgenerated";

type ViewJobData = ViewjobQueryResult["data"];

type RenderableViewJobData = NonNullable<ViewJobData> & {
  viewjob: NonNullable<NonNullable<ViewJobData>["viewjob"]>;
};

export function hasRenderableViewJob(data: ViewJobData): data is RenderableViewJobData {
  return data?.viewjob?.job != null && data.viewjob.details != null;
}
